import request from './base/api';
import { getMemberId } from '@/store/utils/member';

export function chooseMember({ type, phone, tax_id, branch_id }, cb, errCb) {
  const config = {
    data: {
      type,
      phone,
      tax_id,
      branch_id
    }
  };

  return request({
    url: 'member/info',
    method: 'post',
    cb,
    errCb,
    config
  });
}

export function fetchLastProgram({ member_id }, cb, errCb) {
  const config = {
    params: {
      member_id
    }
  };

  return request({
    url: 'member/last-program',
    method: 'get',
    cb,
    errCb,
    config
  });
}

export function fetchMemberById(cb, errCb) {
  let id = getMemberId();

  return request({
    url: 'members/' + id,
    method: 'get',
    cb,
    errCb
  });
}

export default {
  chooseMember,
  fetchLastProgram,
  fetchMemberById
};
